/**
 *
 * @component   项目验收报告TAB
 *
 **/

import React, { memo } from 'react';
import { Form, Image, Rate } from 'antd';
import { queryProjectAudit } from '@/api/personCenter/projectSpace1.4';
import BaseListWrap from '&/components/BaseListWrap';
import moment from 'moment';
import './ProjectCheck.scss';

function ProjectCheck(props) {
    const { previewVideo, projectId } = props;
    const StatusIcon = ({ type }) => {
        const files = ['fail', 'success'];
        return (
            <img
                draggable={false}
                className="status-icon"
                src={
                    require(`@/assets/img/userCenter/${files[type]}.png`)
                        .default
                }
            />
        );
    };

    useEffect(() => {
        queryAudit();
    }, []);

    const [result, setResult] = useState({ project: {}, plan: [] });
    const [isLoading, setIsLoading] = useState(false);
    const [isEmpty, setisEmpty] = useState(false);

    function queryAudit() {
        setIsLoading(true);
        queryProjectAudit({
            projectId,
        })
            .then(({ data }) => {
                data.plan = data.plan.map((el, idx) => ({
                    ...el,
                    num: idx + 1,
                }));
                setResult(data);
                setisEmpty(true);
            })
            .catch(() => {
                setisEmpty(false);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    //   渲染动态列表里的  附件
    const calcAccessory = (list = []) => {
        const IMAGES = list.filter(el => el.fileType === '1');
        const [VIDEO] = list.filter(el => el.fileType === '2');

        return (
            <>
                {!!IMAGES.length && (
                    <div className="media-content-image">
                        <Image.PreviewGroup>
                            {IMAGES.map((el, idx) =>
                                idx < 4 ? (
                                    <Image
                                        data-num={`${
                                            IMAGES.length - 4 > 0
                                                ? '+' + (IMAGES.length - 4)
                                                : ''
                                        }`}
                                        key={idx}
                                        src={el.thumbUrl}
                                    />
                                ) : (
                                    <div className="hide-image" key={idx}>
                                        <Image src={el.thumbUrl} />
                                    </div>
                                )
                            )}
                        </Image.PreviewGroup>
                    </div>
                )}

                {VIDEO && (
                    <div
                        className="media-content-video"
                        onClick={() => previewVideo(VIDEO.originalUrl)}>
                        <Image
                            preview={false}
                            src={VIDEO.thumbUrl}
                            alt={intl.get('projectSpace.videoCover')}
                            fallback={
                                require('@/assets/img/userCenter1.4/xqdefault.png')
                                    .default
                            }
                        />
                        <i className="filled icon-play-circle2 play-btn"></i>
                    </div>
                )}
            </>
        );
    };

    const checkStatus = [
        {
            icon: 'info-circle2',
            title: intl.get('userCenter.notPass'),
            classType: 'danger-type',
        },
        {
            icon: 'Confirm',
            title: intl.get('base.qualified'),
            classType: 'success-type',
        },
    ];

    return (
        <div className="project-check">
            <BaseListWrap isLoading={isLoading} isEmpty={isEmpty}>
                <section className="form-group">
                    <Form.Item label={intl.get('userCenter.accepter')}>
                        {result.project.checkName}
                    </Form.Item>
                    <Form.Item label={intl.get('userCenter.acceptancePhase')}>
                        <span
                            className={`${
                                checkStatus[result.project.status || -1]
                                    ?.classType
                            } project-check-status`}>
                            <i
                                className={`filled  icon-${
                                    checkStatus[result.project.status || -1]
                                        ?.icon
                                }`}></i>
                            {checkStatus[result.project.status || -1]?.title}
                        </span>
                    </Form.Item>
                    <Form.Item label={intl.get('userCenter.acceptanceTime')}>
                        {result.project.checkDate &&
                            moment
                                .unix(result.project.checkDate)
                                .format('YYYY-MM-DD HH:ss')}
                    </Form.Item>
                </section>

                {result.plan.some(el => el.status === '1') && (
                    <section className="form-group">
                        <div className="group-title">
                            {intl.get('userCenter.acceptanceProject')}
                        </div>
                        <div className="item-wrap">
                            {result.plan.map(e => {
                                return (
                                    e.status === '1' && (
                                        <div
                                            className="success-item"
                                            key={e.id}>
                                            {`${e.num}、${e.planName}`}
                                            <StatusIcon type={e.status} />
                                        </div>
                                    )
                                );
                            })}
                        </div>
                    </section>
                )}
                {result.project.status === '0' && (
                    <section className="form-group">
                        <div className="group-title">
                            {intl.get('userCenter.acceptanceFailedProject')}
                        </div>
                        {result.plan.map(e => {
                            return (
                                e.status === '0' && (
                                    <React.Fragment key={e.id}>
                                        <div className="danger-item" key={e.id}>
                                            {`${e.num}、${e.planName}`}
                                            <StatusIcon type={e.status} />
                                        </div>
                                        <div className="fail-reason">
                                            <p className="fail-reason__text">
                                                {e.remark}
                                            </p>
                                            {calcAccessory(e.adjunctData)}
                                        </div>
                                    </React.Fragment>
                                )
                            );
                        })}
                    </section>
                )}
                <section className="form-group">
                    <div className="rate-item">
                        <div>{intl.get('userCenter.designSatisfaction')}</div>
                        <Rate
                            className="custom-rate"
                            disabled
                            value={result.project.drawingScore}
                        />
                    </div>

                    <div className="rate-item">
                        <div>
                            {intl.get('userCenter.constructionSatisfaction')}
                        </div>
                        <Rate
                            className="custom-rate"
                            disabled
                            value={result.project.planScore}
                        />
                    </div>
                </section>
                {result?.project?.adjunctData?.length > 0 && (
                    <section className="form-group">
                        <div className="group-title">
                            {intl.get('userCenter.picturesAndVideos')}
                        </div>
                        {calcAccessory(result.project.adjunctData)}
                    </section>
                )}
                <div className="signature-block">
                    {intl.get('userCenter.signatureOwner')}
                    <img
                        className="signature-image"
                        src={result.project.signaturePath}></img>
                </div>
            </BaseListWrap>
        </div>
    );
}

export default memo(ProjectCheck);
